import { initializeApp } from 'firebase/app'
import type { User } from 'firebase/auth'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { userLogout } from '~/scripts/auth/applicationAuth'
import { initializeSnowflakeQueries } from '~/scripts/snowflake/initializeSnowflake'

// import { getAnalytics } from 'firebase/analytics'

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()

    let firebaseConfig = config.public.firebaseConfig as any
    // If firebaseConfig is a string, parse it
    if (typeof firebaseConfig === 'string') firebaseConfig = JSON.parse(firebaseConfig)

    const app = initializeApp(firebaseConfig)

    // const analytics = getAnalytics(app);
    const auth = getAuth(app)
    const firestore = getFirestore(app)
    const functions = getFunctions(app)

    if (config.public.useFunctionEmulation) {
        console.log('Using Local Cloud Function Emulation on 127.0.0.1 Port 5001')
        connectFunctionsEmulator(functions, '127.0.0.1', 5001)
    }
    if (config.public.useFirestoreEmulation) {
        console.log('Using Local Firestore Emulation on 127.0.0.1 Port 8080')
        connectFirestoreEmulator(firestore, '127.0.0.1', 8080)
    }

    // //////////////////////////////////////////////////////////////////
    // Watches Authentication State
    // //////////////////////////////////////////////////////////////////
    const user = useState<User | null>('user', () => null)

    // //////////////////////////////////////////////////////////////////
    // 💬 Watch Authentication & Data Initialization
    // //////////////////////////////////////////////////////////////////
    const userCookie = useCookie('user', { maxAge: 180 * 60 })

    // const { $auth } = useNuxtApp()
    const { syncAccountProfile, syncUserProfile, alertSnackbar } = useGlobalsStore()
    const authStore = useAuthStore()

    // Watches For Changes in User Authentication State
    onAuthStateChanged(auth, (authUser) => {
        authStore.setUser(authUser)
        console.log('Auth User:', authUser)

        // Checks Global accountId
        const { accountId, userId } = storeToRefs(useGlobalsStore())

        // If Authenticated and Data is Needed
        // If Account ID is null then get sync data
        if (!accountId.value && authUser) {
            // TODO: Temp Measure To Change AccountId: 1 => AccountId: 1712000000000
            accountId.value = authUser.displayName
            userId.value = authUser.uid
            if (authUser.displayName === '1') accountId.value = '1712000000000'

            // Set Auth Cookie
            userCookie.value = JSON.stringify({ uid: authUser.uid, email: authUser.email })
            console.log('User Successfully Logged In', authUser)
            if (accountId.value) initializeGlobalData(accountId.value, authUser.uid)
        }

        // If Not Authenticated and Data Should be Cleared
        if (accountId.value && !authUser) {
            console.warn('Snowflake Has Logged You Out. Please Log In Again.')
            alertSnackbar('Snowflake Has Logged You Out. Please Log In Again.', 'error', 5000)
            userLogout()
        }
    })

    // //////////////////////////////////////////////////////////////////
    // 💬 Data Initialization - If User is Authenticated
    // //////////////////////////////////////////////////////////////////
    function initializeGlobalData(accountId: string, uid: string) {
        // Subscribe to the Account and User Profile Docs From Firestore
        syncAccountProfile(accountId)
        syncUserProfile(accountId, uid)

        // Initialize Snowflake Queries - currentRole, currentWarehouse, etc.
        initializeSnowflakeQueries()
    }

    // nuxtApp.vueApp.provide('auth', auth)
    // nuxtApp.provide('auth', auth)

    // nuxtApp.vueApp.provide('firestore', firestore)
    // nuxtApp.provide('firestore', firestore)

    // nuxtApp.vueApp.provide('cloudFunctions', functions)
    // nuxtApp.provide('cloudFunctions', functions)
    return {
        provide: {
            auth,
            firestore,
            cloudFunctions: functions,
            user,
        },
    }
})
